import {useState} from 'react';

function useToggle() {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);
  const setOn = () => setOpen(true);
  const setClose = () => setOpen(false);

  return {open, setOn, setClose, toggle};
}

export default useToggle;
